import React from 'react';
import SbEditable from 'storyblok-react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	amount: {
		color: theme.palette.primary[500],
		display: 'block',
		fontSize: theme.typography.h1.fontSize,
	},
	description: {
		color: theme.palette.text.primary,
		display: 'block',
		fontSize: theme.typography.h2.fontSize,
		fontWeight: 'normal',
		margin: theme.spacing(2, 0),
		textAlign: 'center',
	},
	metric: {
		textAlign: 'center',
	},
}));

const Metric = ({ blok }) => {
	const classes = useStyles();

	return (
		<SbEditable content={blok}>
			<Grid container justify="center" direction="column">
				<Typography
					variant="h2"
					component="h3"
					className={classes.metric}
				>
					<Typography component="span" className={classes.amount}>
						{blok.amount}{' '}
						<Typography
							component="span"
							className={classes.description}
						>
							{blok.description}
						</Typography>
					</Typography>
				</Typography>
			</Grid>
		</SbEditable>
	);
};

export default Metric;
